import * as yup from "yup";

export const authSchema = yup.object().shape({
  email: yup.string().email("enter_valid_email").required("email_required"),
  password: yup.string().min(8, "passwor_min_8_characters").required("password_required"),
});
